/* eslint-disable react/prop-types */
import classes from "./composed-view-banner-partner.module.scss";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import classNames from "classnames";
import * as announcementHelper from "@/common/announcement-helper";
function ComposedViewBannerPartner({ image, className, onClick }) {
  return (
    <div className={classNames(className)}>
      <Flex
        align="center"
        direction="row"
        justify="space-between"
        className={classNames(classes.container)}
      >
        <img
          src={image ? image : announcementHelper.PLACEHOLDER}
          alt="Logo"
          className={classes.image}
        />
        <Button
          onClick={onClick}
          size="sm"
          color="primary"
          className={classes.button}
        >
          VISITA IL SITO
        </Button>
      </Flex>
    </div>
  );
}

export default ComposedViewBannerPartner;
